import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Tr, TypeUtils } from '@utils';
import { Organization, Permission } from '@services';
import { Divider, Grid, Stack } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps, FormikTextfield, FormikSubmitButton } from '@components/common';
import { FormStepQuestion } from '@components/portal/common';

type EntityType = Organization;
type FormFields = Extendable<{
	name: string;
	domain: string;
	address: string;
	vat: string;
	latitude?: number;
	longitude?: number;
	permissions: Permission[];
}>;

const getInitialValues = (entity?: EntityType) => ({
	name: entity?.name || '',
	// domain: entity?.domain || '',
	// address: entity?.address || '',
	// vat: entity?.vat || '',
	permissions: entity?.permissions || []
});

export interface IClientAccountAddUpdateDialogProps extends IVoltaageModalDialogProps {
	entity?: EntityType;
	onPrimaryButtonClick?: (entity: Partial<EntityType>) => void;
}

export const ClientAccountAddUpdateDialog: FC<IClientAccountAddUpdateDialogProps> = ({ entity, onPrimaryButtonClick, ...props }) => {
	const { t } = useTranslation('portal');
	const { open } = props;
	const formik = useFormik<FormFields>({
		initialValues: getInitialValues(entity),
		validateOnChange: true,
		validationSchema: yup.object({
			name: yup.string().required(t('field-required'))
			// domain: yup.string().required(t('field-required')),
			// address: yup.string().required(t('field-required')),
			// vat: yup.string().required(t('field-required'))
		}),
		onSubmit: ({ name, permissions: _permissions }, api) => {
			api.setSubmitting(false);
			onPrimaryButtonClick?.(
				TypeUtils.convert(Organization, {
					...entity,
					name,
					// domain,
					// address,
					// vat,
					permissions: Object.values(Permission)
				})
			);
		}
	});

	useEffect(() => {
		open && formik.resetForm({ errors: {}, values: getInitialValues(entity) });
	}, [open]);

	return (
		<VoltaageModalDialog title={<Tr.Portal path="client-account.add-edit-view-modal-title" />} dividers {...props}>
			<form onSubmit={formik.handleSubmit}>
				<Stack direction="column" sx={{ paddingX: 14, paddingY: 4, width: 1.0 }} spacing={3}>
					<FormStepQuestion title={<Tr.Portal path="client-account.assign-client-account-detail" />}>
						<Grid container rowSpacing={2} columnSpacing={3}>
							<Grid item xs={12}>
								<FormikTextfield
									formikApi={formik}
									name="name"
									title={t('client-account.client-account-name')}
									placeholder={t('client-account.client-account-name-placeholder')}
									fullWidth
									required
								/>
							</Grid>
							{/* <Grid item xs={6}>
								<FormikTextfield
									formikApi={formik}
									name="vat"
									title={t('client-account.vat-code')}
									placeholder={t('client-account.vat-code-placeholder')}
									fullWidth
									required
								/>
							</Grid>
							<Grid item xs={6}>
								<FormikTextfield
									formikApi={formik}
									name="domain"
									title={t('client-account.domain-name')}
									placeholder={t('client-account.domain-name-placeholder')}
									fullWidth
									required
								/>
							</Grid>
							<Grid item xs={6}>
								<FormikTextfield
									formikApi={formik}
									name="address"
									title={t('client-account.address')}
									placeholder={t('client-account.address-placeholder')}
									fullWidth
									required
								/>
							</Grid> */}
						</Grid>
					</FormStepQuestion>
					<Divider light />

					{/* <FormStepQuestion title={<Tr.Portal path="client-account.assign-client-account-capabilities" />}>
						<Grid container columnSpacing={2}>
							{Object.values(Permission)
								.filter(isPermissionVisible)
								.map((permission, i) => (
									<Grid item xs={4} key={`permission-${permission}-${i}`}>
										<PermissionCheckbox formikApi={formik} name="permissions" value={permission} />
									</Grid>
								))}
						</Grid>
					</FormStepQuestion>
					<Divider light /> */}

					<FormikSubmitButton formik={formik} data-testid="add-update-client-account-form-submit-button">
						<Tr.Portal path={entity ? 'client-account.update-client-account' : 'client-account.add-client-account'} />
					</FormikSubmitButton>
				</Stack>
			</form>
		</VoltaageModalDialog>
	);
};
